var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('task-list',{attrs:{"task-lists":_vm.taskLists}})],1),_c('b-col',{attrs:{"cols":"8"}},[_c('task-group',{attrs:{"task-list-id":_vm.listId,"tasks":_vm.tasks}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }